<div class="card row"
     [class.selected]="highlighted"
     [class.done]="task.status===1"
     [class.not-done]="task.status===2"
     [class.greyed-out]="task.canStart === false"
     (click)="toggleHighlighted($event)"
>
    <div class="circle"
         *ngIf="canSelect && task.status === 0"
         [class.filled]="selected"
         (click)="toggleSelected($event)">
    </div>

    <span class="fa-stack left-icon">
    <i class="fa fa-stack-2x"
       [class.fa-square-o]="task.status===0 || task.status===2"
       [class.fa-check-square-o]="task.status===1"
    ></i>
    <i class="fa"
       [class.fa-cog]="task.status===0"
       [class.stack-top-right]="task.status===0"
       [class.fa-exclamation]="task.status===2"
       [class.fa-stack-1x]="task.status===2"
    ></i>
  </span>

    <div class="text-container">
        <strong>{{ task.name }}</strong>
        <p class="description">{{ task.description }}</p>
        <strong>{{ task.identifier }}</strong>
    </div>

    <div class="cogs" *ngIf="displayCogs">
        <i class="fa fa-cog big-cog"></i>
        <i class="fa fa-cog small-cog"></i>
    </div>

    <div class="text-container right">
        <div>
            <i *ngIf="hasObservations" class="fa fa-commenting"></i>
        </div>
        <p class="info">{{ info }}</p>
    </div>

    <span *ngIf="canDuplicate" class="fa-stack right-icon">
    <i class="fa fa-files-o fa-stack-2x" (click)="onDuplicate($event)"></i>
  </span>

    <span *ngIf="canDelete" class="fa-stack right-icon">
    <i class="fa fa-trash fa-stack-2x" (click)="onDelete($event)"></i>
  </span>

</div>
